import { Children, type ReactNode, type CSSProperties } from "react";
import { cn } from "@repo/utils";
import type { Sizes } from "../button/button.types.js";

export type Props = {
  children: ReactNode;
  size?: Sizes;
  className?: string;
  isOpen?: boolean;
};

const curveHeights: Record<string, number> = {
  sm: 18,
  md: 22,
  lg: 26,
  xl: 30,
};

export type NavTreeItemProps = {
  children: ReactNode;
  showLines?: boolean;
};

export const NavTreeItem = ({ children, showLines = true }: NavTreeItemProps) => {
  return <div className={cn({ "tree-curve": showLines })}>{children}</div>;
};

export const NavTree = ({ children, size = "md", className, isOpen = true }: Props) => {
  if (!isOpen || !children) return null;

  const curveHeight = curveHeights[size] ?? 22;

  return (
    <div
      className={cn(
        "tree-container pl-5",
        {
          "ml-[10px]": size === "sm",
          "ml-[14px]": size === "md",
          "ml-[18px]": size === "lg",
          "ml-[22px]": size === "xl",
        },
        className
      )}
      style={
        {
          "--tree-curve-height": `${curveHeight}px`,
        } as CSSProperties
      }
    >
      {Children.map(children, (child) => {
        return child;
      })}
    </div>
  );
};

NavTree.displayName = "NavTree";
